// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3d2d40ca","455":"f799afe9","977":"98d1e039"}[chunkId] + ".chunk.js";
};